import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Space, Typography } from "antd";
import { MailOutlined, LockOutlined, WarningOutlined } from "@ant-design/icons";
import axios from "axios";
import { PATH } from "../../redux/utils";
import { sessionManager } from "../../redux/sessionManager";
import { performLogout } from "../../utils/logout";
import { toast } from "../toasts/toastStore";

const { Title, Text } = Typography;

export default function ModalReautenticar({ open, onClose }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ correo: localStorage.getItem("email") || "" });
    }
  }, [open, form]);

  const handleSubmit = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    setLoading(true);
    try {
      const { data } = await axios.post(
        `${PATH}/auth/login`,
        { correo: values.correo, password: values.password },
        { headers: { "Content-Type": "application/json" } }
      );

      const token = data?.access_token;
      if (!token) throw new Error("Respuesta invalida del servidor");

      localStorage.setItem("token", token);
      localStorage.setItem("email", values.correo);
      if (data?.role) localStorage.setItem("role", data.role);

      sessionManager.onAuthSuccess(token);
      window.dispatchEvent(new Event("permisos-refresh"));
      form.resetFields();
      onClose();
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || "Correo o contraseña incorrectos";
      toast.error(msg || "Error al autenticar");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    sessionManager.onAuthFailure();
    performLogout();
  };

  return (
    <Modal
      open={open}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      width={440}
      footer={null}
    >
      <div style={{ padding: "8px 4px 16px" }}>
        <Space size={12} align="center">
          <WarningOutlined style={{ fontSize: 20, color: "#dc2626" }} />
          <div>
            <Title level={4} style={{ margin: 0, lineHeight: 1.2 }}>
              Sesión expirada
            </Title>
            <Text type="secondary">Vuelve a iniciar sesión para continuar.</Text>
          </div>
        </Space>

        <Form form={form} layout="vertical" requiredMark="optional" onFinish={handleSubmit} style={{ marginTop: 18 }}>
          <Form.Item
            label="Correo electrónico"
            name="correo"
            rules={[{ required: true, message: "El correo es obligatorio." }]}
          >
            <Input size="large" prefix={<MailOutlined />} disabled={loading} />
          </Form.Item>

          <Form.Item
            label="Contraseña"
            name="password"
            rules={[{ required: true, message: "La contraseña es obligatoria." }]}
          >
            <Input.Password size="large" prefix={<LockOutlined />} disabled={loading} autoFocus />
          </Form.Item>

          <Space style={{ width: "100%", justifyContent: "space-between" }}>
            <Button danger onClick={handleLogout} disabled={loading}>
              Cerrar sesión
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{ background: "#5778c3", borderColor: "#5778c3" }}
            >
              Iniciar sesión
            </Button>
          </Space>
        </Form>
      </div>
    </Modal>
  );
}
